// Exported type constants
export const ACTION = 'action';
export const ARRAY = 'array';
export const BOOLEAN = 'boolean';
export const COMPONENT = 'component';
export const FUNCTION = 'function';
export const NUMBER = 'number';
export const OBJECT = 'object';
export const STRING = 'string';

// Internal constants
export const CONFIG_OPTION = 'configOption';
export const FORBIDDEN = 'forbidden';
export const OPTIONAL = 'optional';
export const NONEXISTENT_OPTIONS = Object.freeze([undefined, null]);
export const REQUIRES = 'requires';
export const VALIDATABLE_TYPES = Object.freeze([
  ACTION,
  ARRAY,
  BOOLEAN,
  COMPONENT,
  CONFIG_OPTION,
  FUNCTION,
  NUMBER,
  OBJECT,
  STRING,
]);

export default {
  ACTION,
  ARRAY,
  BOOLEAN,
  COMPONENT,
  NUMBER,
  OBJECT,
  STRING,
  CONFIG_OPTION,
  FORBIDDEN,
  FUNCTION,
  OPTIONAL,
  NONEXISTENT_OPTIONS,
  REQUIRES,
  VALIDATABLE_TYPES,
};
